<div class="content-div" fxLayout="column" fxLayoutGap="5%" fxLayoutAlign="space-evenly center"
fxLayoutAlign.xs="space-between center" fxLayoutAlign.xs="space-between center" style="margin: 40px 0;">
  <img src="assets/images/404/404.jpg" />
  <button mat-flat-button [color]="'primary'" style="height:50px;width:200px;color:#fff;font-size:20px;"  [routerLink]="['/']">Go To Homepage</button>
</div>